module.exports = __webpack_public_path__ + "img/medicalServiceLogo.f4e04ae7.jpg";